var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifierMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,22.3l-4.2-4.5c-0.6,0.5-1.3,0.9-2.1,1.2c-0.8,0.3-1.7,0.4-2.6,0.4c-2.2,0-4.1-0.8-5.7-2.3 s-2.3-3.4-2.3-5.6c0-2.2,0.8-4.1,2.3-5.6c1.6-1.5,3.4-2.3,5.6-2.3c2.2,0,4.1,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6 c0,0.9-0.1,1.7-0.4,2.5c-0.3,0.8-0.7,1.6-1.2,2.3L22,21L20.4,22.3z M11.5,17.3c1.6,0,3-0.6,4.1-1.7c1.1-1.1,1.7-2.5,1.7-4.1 c0-1.6-0.6-3-1.7-4.1c-1.1-1.1-2.5-1.7-4.1-1.7c-1.6,0-3,0.6-4.2,1.7c-1.1,1.1-1.7,2.5-1.7,4.1c0,1.6,0.6,3,1.7,4.1 C8.4,16.7,9.8,17.3,11.5,17.3z M8,12.3v-1.8h6.7v1.8H8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierMinus);
export default __webpack_public_path__ + "static/media/magnifier-minus.ce04a12a160536fb21f8315b957ed130.svg";
export { ForwardRef as ReactComponent };